<template>
    <DadosBancariosShared 
        ref="dadosBancariosShared"
        tipoCliente="Fundos" 
        :Edicao="Edicao" 
    />
</template>

<script>
import DadosBancariosShared from '@/views/Cadastro/Shared/DadosBancarios.vue'

export default {
    name: 'CadastroFI_DadosBancarios',
    components: { DadosBancariosShared },
    props: ['Edicao'],
    methods: {
        proximaEtapa() {
            if (this.$refs.dadosBancariosShared) {
                return this.$refs.dadosBancariosShared.proximaEtapa();
            }
        },
        validarFormulario(submeter) {
            if (this.$refs.dadosBancariosShared) {
                return this.$refs.dadosBancariosShared.validarFormulario(submeter);
            }
            return true;
        },
        salvarInformacoes() {
            if (this.$refs.dadosBancariosShared) {
                return this.$refs.dadosBancariosShared.salvarInformacoes();
            }
        }
    }
}
</script>
